import { DialogComponent } from '@theme/dialog';

/**
 * Left slideout shop drawer.
 *
 * Extends Horizon's `DialogComponent` so it inherits open/close lifecycle,
 * focus trap, ESC handling, body scroll lock, click-outside-to-close, and
 * dispatches `dialog:open` / `dialog:close` events — same contract as cart
 * drawer.
 *
 * Triggers:
 *   - Declarative: `on:click="shop-drawer-component/showDialog"` on any element.
 *   - Legacy: any `<a href="#shop-drawer">` link (merchants set these in nav).
 */
class ShopDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this.#handleTabClick);
    document.addEventListener('click', this.#handleLegacyTrigger, true);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this.#handleTabClick);
    document.removeEventListener('click', this.#handleLegacyTrigger, true);
  }

  open = () => this.showDialog();
  close = () => this.closeDialog();

  #handleLegacyTrigger = (event) => {
    const trigger = event.target?.closest?.('a[href*="#shop-drawer"]');
    if (!trigger) return;
    event.preventDefault();
    this.showDialog();
  };

  #handleTabClick = (event) => {
    const tab = event.target?.closest?.('[data-shop-drawer-tab]');
    if (!tab) return;
    this.#activateTab(tab.dataset.shopDrawerTab);
  };

  #activateTab(tabId) {
    const { dialog } = this.refs;
    if (!dialog) return;

    dialog.querySelectorAll('.shop-drawer__tab').forEach((t) => {
      const active = t.dataset.shopDrawerTab === tabId;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    dialog.querySelectorAll('[data-shop-drawer-panel]').forEach((p) => {
      const active = p.dataset.shopDrawerPanel === tabId;
      p.classList.toggle('is-active', active);
      p.hidden = !active;
    });
  }
}

if (!customElements.get('shop-drawer-component')) {
  customElements.define('shop-drawer-component', ShopDrawerComponent);
}
